import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { StateService } from './state.service';
import { HttpClient,HttpHeaders,HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map,catchError,switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private apiSvc: ApiService, private http: HttpClient, private authSvc: AuthService, private stateSvc: StateService) { }
  
	getVehicleStates(stt){
		// device status
		// 0: Offline
		// 1: Driving
		// 2: Parking
		// 3: Never online
		// 4: Expired
		// 5:Idling
		let arrStts:any = {
			0: "Offline",
			1: "Driving",
			2: "Parking",
			3: "Never online",
			4: "Expired",
			5:"Idling"
		};
		return arrStts[stt];
	}

	getVehicleTracksolidStates(stt, gpsTime){
		// device status
		// 0: Offline
		// 1: Driving
		// 2: Parking
		// 3: Never online
		// 4: Expired
		// 5:Idling
		let arrStts:any = {
			"0": "Offline",
			"1": "Online"
		};

		let defaultState = arrStts[stt];
		if(gpsTime){
			let currentDate = new Date();
			let localTime:any = null;
			currentDate.setTime(currentDate.getTime() - 86400000);
			const date = new Date(gpsTime.replace(' ', 'T') + '+08:00');
			date.setTime(date.getTime() + 28800000);
			localTime = date;
			if(currentDate.getTime() < localTime.getTime()){
				defaultState = 'Time';
			}
		}
		return defaultState;
	}

	getEngineStatus(stt){
		let engStts:any = {
			0: "On",
			1: "Off"
		};
		let result = engStts[stt];
		if(!result){
			result = '-';
		}
		return result;
	}

	getEngineTracksolidStatus(stt){
		let engStts:any = {
			"0": "On",
			"1": "Off"
		};
		let result = engStts[stt];
		if(!result){
			result = '-';
		}
		return result;
	}

	getHeadingVehicle(bearing){
		if(bearing >= 0 && bearing <= 180){
			return "East";
		}else if(bearing > 180 && bearing <= 360){
			return "West";
		}
	}

	getSymbolMapping(typeEn){
		if(typeEn.toLowerCase() == "truck"){
			return 0;
		}else if(typeEn.toLowerCase() == "car"){
			return 19;
		}else if(typeEn.toLowerCase() == "bus"){
			return 15;
		}else if(typeEn.toLowerCase() == "oil tank truck"){
			return 5;
		}else if(typeEn.toLowerCase() == "agitator truck"){
			return 13;
		}else if(typeEn.toLowerCase() == "excavator"){
			return 35;
		}else if(typeEn.toLowerCase() == "motorcycle"){
			return 33;
		}else if(typeEn.toLowerCase() == "taxi"){
			return 39;
		}else{
			return 19;
		}
	}

	getTracksolidSymbolMapping(typeEn){
		if(typeEn.toLowerCase() == "truck"){
			return 0;
		}else if(typeEn.toLowerCase() == "automobile"){
			return 19;
		}
		// else if(typeEn.toLowerCase() == "bus"){
		// 	return 15;
		// }
		else if(typeEn.toLowerCase() == "mtc"){
			return 33;
		}else{
			return 49;
		}
	}
 
  getVehicles(uname=null): Observable <any>{
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	// encrypt using blowfish library
	let hash = "";
	if(!user && uname){
		hash = this.authSvc.hashBlowfish(uname);
	}else{
		if(uname){
			hash = this.authSvc.hashBlowfish(uname);
		}else{
			hash = user.hash;
		}
	}
	
	// get URL Endpoint from APIService
	let endpoint = this.apiSvc.getEndpointUrl();
	let iconbase = this.apiSvc.getIconbase();
	// set full URL to be requested
	let fullPathUrl = endpoint + 'GetMobiles/' + hash;
	
	let tmpShowns:any = [];
	if(localStorage.getItem('markerShown')){
		tmpShowns = JSON.parse(localStorage.getItem('markerShown'));
	}
	
	// existing vehicles
	let existings = this.stateSvc.staticVehicle;
	
	let canShowMultiple = this.stateSvc.showMulVehicles;
	let currentMapProvider = this.stateSvc.getMapType();
	
	// send to backend via API service, standard place to perform HTTP transfer
	return this.http.get(fullPathUrl)
	.pipe(
		map((results:any) => {
			if (results.length == 0) {
				// no vehicle found from backend
				throw new Error('No vehicle found');
			}
			// set vehicle object
			let vechiles:any = [];
			let vehicleGroups:any = [];
			let toUpdateCoords:any = {};
			let prevCoords = this.stateSvc.getPrevCoords();
			results.forEach((res) => {
				let vehicle:any = this.apiSvc.wsr2obj(res);
				if(user && !uname){
					if(user.username != user.owner && vehicle.subaccountname.toLowerCase() != user.username.toLowerCase()) {
						return;
					}
				}
				if (vehicle.engine == 'On' && vehicle.event != 'Idling') {
					vehicle.status = 'active';
				} else if (vehicle.engine == 'On' && vehicle.event == 'Idling') {
					vehicle.status = 'idle';
				} else if (vehicle.engine == 'Off') {
					vehicle.status = 'stop';
				}
				vehicle.coordinate = vehicle.lat + ', ' + vehicle.lon;
				vehicle.is_moving = false;
				if(prevCoords[vehicle.unitid] && prevCoords[vehicle.unitid] != vehicle.coordinate){
					vehicle.is_moving = true;
				}
				let othersAttr = (parseFloat(vehicle.trailerid)).toFixed(2);
				vehicle.batteryPercent = "-";
				if((vehicle.trailerid == "" || vehicle.trailerid == 0) && vehicle.battery && (vehicle.battery).indexOf('|') > -1){
					let strBatt = (vehicle.battery).split('|');
					if(strBatt[8]){
						vehicle.batteryPercent = strBatt[8] + "%";
						othersAttr = vehicle.batteryPercent;
					}
				}
				vehicle.convertedTime = vehicle.updated.format('DD-MM-YYYY HH:mm:ss');
				vehicle.toggleInfoWdw = false;
				vehicle.fuelValue = (parseFloat(vehicle.level) + parseFloat(vehicle.tankreserve)).toFixed(2);
				vehicle.otherAttribute = othersAttr;
				vehicle.geolocation = "";
				// vehicle.infowWindowContent = "<div class='vehicle--summary-header "+vehicle.unitid+"'><span class='vehicle--plate '>" + vehicle.description + "</span></div>" +
				// 	"<div><small class='text-muted'>" + vehicle.convertedTime + "</small></div>" +
				// 	"<div>Driver: " + vehicle.drivernamedefault + "</div>" +
				// 	"<div>Engine: " + vehicle.engine + "</div>" +
				// 	"<div>Speed: " + vehicle.speed + "</div>" +
				// 	"<div>Direction: " + vehicle.direction + "</div>" +
				// 	"<div>Desc: " + vehicle.description + "</div>" +
				// 	"<div>Fuel: " + (parseFloat(vehicle.level) + parseFloat(vehicle.tankreserve)).toFixed(2) + "</div>" +
				// 	"<div>Others: " + othersAttr + "</div>";
				vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.location);
				// this.reverseGeocode(vehicle.lat, vehicle.lon)
				// .subscribe((res) => {
				// 	if(res && res != ""){
				// 		let currentGeoLoc = res;console.log(vehicle.description, currentGeoLoc)
				// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, currentGeoLoc);
				// 	}
				// })
				vehicle.markerPosition = {lat: vehicle.lat, lng: vehicle.lon};
				vehicle.markerPositionOsm = [vehicle.lat, vehicle.lon];
				let olediExist = false;
				let existing:any = {};
				if(existings.length > 0){
					existings.forEach((ex) => {
						if(ex.unitid == vehicle.unitid){
							olediExist = true;
							existing = ex;
							return;
						}
					});
				}
				if(olediExist){
					vehicle.shownOnMap = existing.shownOnMap;
					
					//vehicle.infoWindow.shown = existing.infoWindow.shown;
					vehicle.marker = existing.marker;
					vehicle.eventLowerCase = existing.eventLowerCase;
					vehicle.odometerInt = parseInt(existing.odometer);
					vehicle.icon = existing.icon;
					if (vehicleGroups.indexOf(vehicle.groupname) == -1) {
						vehicleGroups.push(vehicle.groupname);
					}

					if(currentMapProvider == "Google"){
						vehicle.infoWindow = existing.infoWindow;
						if(vehicle.infoWindow.shown){
							let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
							if(!arrayCoords){
								// this.reverseGeocode(vehicle.lat, vehicle.lon)
								// .subscribe((res) => {
								// 	if(res && res != ""){
								// 		vehicle.geolocation = res;
								// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
								// 		vehicle.infoWindow.setContent(vehicle.infowWindowContent);
								// 	}
								// })
							}else{
								vehicle.geolocation = arrayCoords;
							}
							vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
							vehicle.infoWindow.setContent(vehicle.infowWindowContent);
						}
						
						if(canShowMultiple){
							vehicle.marker.setPosition(vehicle.markerPosition);
							vehicle.infoWindow.setContent(vehicle.infowWindowContent);
						}
					}else{
						vehicle.toggleInfoWdw = existing.toggleInfoWdw;
						let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
						if(!arrayCoords){
							// this.reverseGeocode(vehicle.lat, vehicle.lon)
							// .subscribe((res) => {
							// 	if(res && res != ""){
							// 		vehicle.geolocation = res;
							// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
							// 		vehicle.infoWindow.setContent(vehicle.infowWindowContent);
							// 	}
							// })
						}else{
							vehicle.geolocation = arrayCoords;
						}
						// vehicle.marker.remove();
						let symbol = vehicle.symboltype + 1;
						if (symbol < 10) {
							symbol = '0' + symbol;
						}
						vehicle.icon = iconbase + symbol + '.png';
						var greenIcon = L.icon({
							iconUrl: iconbase + symbol + '.png'
						});
						vehicle.greenIcon = greenIcon;

						vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
						var newLatLng = new L.LatLng(vehicle.lat, vehicle.lon);
						vehicle.marker.setLatLng(newLatLng);// = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
						vehicle.marker.bindPopup(vehicle.infowWindowContent);

						vehicle.marker.on('popupclose', function(e) {
							vehicle.toggleInfoWdw = false;
						});
						vehicle.marker.on('popupopen', function(e) {
							vehicle.toggleInfoWdw = true;
						});
						if(vehicle.shownOnMap && canShowMultiple){
							vehicle.marker.addTo(this.stateSvc.mapStatic);
						}
					}
				}else{
					vehicle.shownOnMap = false;
					if(tmpShowns.length > 0){
						tmpShowns.forEach((mkr) => {
							if(mkr.unitid == vehicle.unitid){
								vehicle.shownOnMap = mkr.shownOnMap;
							}
						});
					}
					let symbol = vehicle.symboltype + 1;
					if (symbol < 10) {
						symbol = '0' + symbol;
					}
					vehicle.icon = iconbase + symbol + '.png';
					if(currentMapProvider == "Google"){
						vehicle.marker = new google.maps.Marker({
							position: vehicle.markerPosition,
							icon: iconbase + symbol + '.png'
						});
						vehicle.infoWindow = new google.maps.InfoWindow({
							content: vehicle.infowWindowContent
						});
						vehicle.infoWindow.shown = false;
						vehicle.marker.addListener('click', () => {
							this.updateInfoWd(vehicle);
							let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
							if(arrayCoords){
								vehicle.geolocation = arrayCoords;
							}
							// let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
							// if(!arrayCoords){
							// 	this.reverseGeocode(vehicle.lat, vehicle.lon)
							// 	.subscribe((res) => {
							// 		if(res && res != ""){
							// 			vehicle.geolocation = res;
							// 			vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
							// 			vehicle.infoWindow.setContent(vehicle.infowWindowContent);
							// 		}
							// 	})
							// }else{
							// 	vehicle.geolocation = arrayCoords;
							// }
							vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
							vehicle.infoWindow.setContent(vehicle.infowWindowContent);
							if (!vehicle.infoWindow.shown) {
								vehicle.infoWindow.open(vehicle.marker?.map, vehicle.marker);
								vehicle.infoWindow.shown = true;
								vehicle.toggleInfoWdw = true;
							} else {
								vehicle.infoWindow.close();
								vehicle.infoWindow.shown = false;
								vehicle.toggleInfoWdw = false;
							}
						});
						google.maps.event.addListener(vehicle.infoWindow,'closeclick',() => {
							vehicle.infoWindow.shown = false;
							vehicle.toggleInfoWdw = false;
							this.updateInfoWd(vehicle);
						});
					}else{
						var greenIcon = L.icon({
							iconUrl: iconbase + symbol + '.png'
						});
						vehicle.greenIcon = greenIcon;

						this.updateInfoWd(vehicle);
						let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
						if(arrayCoords){
							vehicle.geolocation = arrayCoords;
						}
						vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
						// if (!vehicle.toggleInfoWdw) {
						// 	vehicle.toggleInfoWdw = true;
						// } else {
						// 	vehicle.toggleInfoWdw = false;
						// }
						
						vehicle.marker = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
						vehicle.marker.bindPopup(vehicle.infowWindowContent);

						vehicle.marker.on('popupclose', function(e) {
							vehicle.toggleInfoWdw = false;
						});
						vehicle.marker.on('popupopen', function(e) {
							vehicle.toggleInfoWdw = true;
						});
						if(vehicle.shownOnMap && canShowMultiple){
							// vehicle.marker.addTo(this.stateSvc.mapStatic);
							if (vehicle.marker._map) {
								console.log('Marker is on the map ' + vehicle.description);
							} else {
								console.log('Marker is NOT on the map ' + vehicle.description);
								// vehicle.marker.addTo(this.stateSvc.mapStatic);
							}
						}
					}
					vehicle.eventLowerCase = vehicle.event.toLowerCase().replace(/_/g, ' ');
					vehicle.odometerInt = parseInt(vehicle.odometer);
					if (vehicleGroups.indexOf(vehicle.groupname) == -1) {
						vehicleGroups.push(vehicle.groupname);
					}
				}
				vechiles.push(vehicle);
				toUpdateCoords[vehicle.unitid] = vehicle.coordinate;
			});
			this.stateSvc.setVehicleGroups(vehicleGroups);
			this.stateSvc.setPrevCoords(toUpdateCoords);
			
			// update in state service, so any component can use the vehicel object
			this.stateSvc.setVehicles(vechiles);
			
			return vechiles;
		}),
		catchError((error:any) => {
			console.log('err', error)
			return throwError(error);
		})
	)
  }

  getVehicleOuts(uname: string | null = null): Observable<any> {
	let userString = sessionStorage.getItem('user');
	let user: any = userString ? JSON.parse(userString) : null;

	let currentMapProvider = this.stateSvc.getMapType();

	return this.getCredentialData().pipe(
		switchMap((sett: any) => {
			if (!sett?.collection_keys?.base_url) {
				return throwError(() => new Error('Invalid credential data'));
			}

			let endpoint = sett.collection_keys.base_url;
			let headKey = sett.collection_keys.master;
			let iconbase = this.apiSvc.getIconbase();
			let fullPathUrl = endpoint + 'monitor/getRealTimeInfo';

			const head = new HttpHeaders()
				.set('version', '1.0')
				.set('Accept-Language', 'en')
				.set('Content-Type', 'application/json')
				.set('key', headKey);
			
			let objIds = this.stateSvc.getUsersVehicleIds();
			// let objStr = objIds.join(',');

			let i:any = {
				queryType:"1",
				queryParams:objIds
			};
			
			let tmpShowns:any = [];
			if(localStorage.getItem('markerShown')){
				tmpShowns = JSON.parse(localStorage.getItem('markerShown'));
			}
			
			// existing vehicles
			let existings = this.stateSvc.staticVehicle;
			
			let canShowMultiple = this.stateSvc.showMulVehicles;
			
			return this.http.post(fullPathUrl, i, { headers: head }).pipe(
				map((results: any) => {
				if (results?.data?.list?.length == 0) {
						// no vehicle found from backend
						throw new Error('No vehicle found');
					}
					// set vehicle object
					let vechiles:any = [];
					let vehicleGroups:any = [];
					let toUpdateCoords:any = {};
					let prevCoords = this.stateSvc.getPrevCoords();
					results?.data?.list?.forEach((res:any) => {
						let vehicle:any = res;
						vehicle.unitid = vehicle.terminalNo;
						vehicle.description = vehicle.plate;
						vehicle.color = vehicle.plateColor;
						vehicle.bearing = vehicle.direct;
						vehicle.direction = this.getHeadingVehicle(vehicle.bearing);
						vehicle.engine = this.getEngineStatus(vehicle.accState);
						vehicle.drivernamedefault = vehicle.driverName;
						vehicle.driveid = vehicle.drivernamedefault? 1 : 0;
						vehicle.symboltype = this.getSymbolMapping(vehicle.vehicleTypeEN);
						vehicle.groupname = vehicle.groupName;
						vehicle.odometer = (vehicle.mileage/1000).toFixed(1);
						vehicle.level = 0;
						vehicle.tankvolume = 0;
						if(user && !uname){
							if(user.username != user.owner && vehicle.subaccountname.toLowerCase() != user.username.toLowerCase()) {
								return;
							}
						}
						let vhcStt = this.getVehicleStates(vehicle.vehicleState);
						vehicle.event = vhcStt;
						if (vehicle.accState == 0 && (vehicle.event == 'Idling')) {
							vehicle.status = 'idle';
						}else if (vehicle.accState == 0 ) {
							vehicle.status = 'active';
						}else if (vehicle.accState == 1) {
							vehicle.status = 'stop';
						}
						vehicle.coordinate = vehicle.lat + ', ' + vehicle.lon;
						vehicle.location = vehicle.coordinate;
						vehicle.menuGeocode = true;
						vehicle.batteryPercent = (parseFloat(vehicle.power || 0)).toFixed(2) + "%";
						let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
						if(arrayCoords){
							vehicle.location = arrayCoords;
						}
						vehicle.is_moving = false;
						if(prevCoords[vehicle.unitid] && prevCoords[vehicle.unitid] != vehicle.coordinate){
							vehicle.is_moving = true;
						}
						let othersAttr = (parseFloat(vehicle.trailerid)).toFixed(2);
						othersAttr = vehicle.batteryPercent;

						const dateStr = vehicle.devTime;
						if(vehicle.devTime){
							// Convert to ISO format (important)
							const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
							// Get milliseconds
							const timestamp = date.getTime();
							// Build .NET format
							const dotNetDate = "/Date(" + timestamp + "+0800)/";
							vehicle.updated = moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x');
							// let currentMoment = moment();
							// let isAfterNow = vehicle.updated.isAfter(currentMoment);
							// vehicle.convertedTime = !isAfterNow? vehicle.updated.format('DD-MM-YYYY HH:mm:ss') : currentMoment.format('DD-MM-YYYY HH:mm:ss');
							// if(isAfterNow){
							// 	vehicle.updated = currentMoment;
							// }
							vehicle.convertedTime = vehicle.updated.format('DD-MM-YYYY HH:mm:ss');
						}else{
							// Convert to ISO format (important)
							const date = '-';
							// Get milliseconds
							const timestamp = '-';
							// Build .NET format
							const dotNetDate = "-";
							vehicle.updated = '-';
							// let currentMoment = moment();
							// let isAfterNow = vehicle.updated.isAfter(currentMoment);
							// vehicle.convertedTime = !isAfterNow? vehicle.updated.format('DD-MM-YYYY HH:mm:ss') : currentMoment.format('DD-MM-YYYY HH:mm:ss');
							// if(isAfterNow){
							// 	vehicle.updated = currentMoment;
							// }
							vehicle.convertedTime = '-';
						}
						vehicle.toggleInfoWdw = false;
						vehicle.fuelValue = (parseFloat(vehicle.firstOilScale)).toFixed(2);
						vehicle.otherAttribute = othersAttr;
						vehicle.fuel_usage = vehicle.firstOilMete;
						vehicle.geolocation = "";
						// vehicle.infowWindowContent = "<div class='vehicle--summary-header "+vehicle.unitid+"'><span class='vehicle--plate '>" + vehicle.description + "</span></div>" +
						// 	"<div><small class='text-muted'>" + vehicle.convertedTime + "</small></div>" +
						// 	"<div>Driver: " + vehicle.drivernamedefault + "</div>" +
						// 	"<div>Engine: " + vehicle.engine + "</div>" +
						// 	"<div>Speed: " + vehicle.speed + "</div>" +
						// 	"<div>Direction: " + vehicle.direction + "</div>" +
						// 	"<div>Desc: " + vehicle.description + "</div>" +
						// 	"<div>Fuel: " + (parseFloat(vehicle.level) + parseFloat(vehicle.tankreserve)).toFixed(2) + "</div>" +
						// 	"<div>Others: " + othersAttr + "</div>";
						vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.location);
						// this.reverseGeocode(vehicle.lat, vehicle.lon)
						// .subscribe((res) => {
						// 	if(res && res != ""){
						// 		let currentGeoLoc = res;console.log(vehicle.description, currentGeoLoc)
						// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, currentGeoLoc);
						// 	}
						// })
						vehicle.markerPosition = {lat: vehicle.lat, lng: vehicle.lon};
						vehicle.markerPositionOsm = [vehicle.lat, vehicle.lon];
						let olediExist = false;
						let existing:any = {};
						if(existings.length > 0){
							existings.forEach((ex) => {
								if(ex.unitid == vehicle.unitid){
									olediExist = true;
									existing = ex;
									return;
								}
							});
						}
						if(olediExist){
							vehicle.shownOnMap = existing.shownOnMap;
							// vehicle.marker = existing.marker;
							vehicle.eventLowerCase = vhcStt;
							vehicle.odometerInt = (existing.mileage/1000).toFixed(1);
							vehicle.icon = existing.icon;
							if (vehicleGroups.indexOf(vehicle.groupname) == -1) {
								vehicleGroups.push(vehicle.groupname);
							}
							if(currentMapProvider == "Google"){
								vehicle.infoWindow = existing.infoWindow;
								//vehicle.infoWindow.shown = existing.infoWindow.shown;

								if(vehicle.infoWindow.shown){
									let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
									if(!arrayCoords){
										// this.reverseGeocode(vehicle.lat, vehicle.lon)
										// .subscribe((res) => {
										// 	if(res && res != ""){
										// 		vehicle.geolocation = res;
										// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
										// 		vehicle.infoWindow.setContent(vehicle.infowWindowContent);
										// 	}
										// })
									}else{
										vehicle.geolocation = arrayCoords;
									}
									vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
									vehicle.infoWindow.setContent(vehicle.infowWindowContent);
								}
								
								// if(canShowMultiple){
								// 	vehicle.marker.setPosition(vehicle.markerPosition);
								// 	vehicle.infoWindow.setContent(vehicle.infowWindowContent);
								// }
							}else{
								vehicle.infoWindow = existing.infoWindow;
								vehicle.toggleInfoWdw = existing.toggleInfoWdw;
								
								let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
								if(!arrayCoords){
									
								}else{
									vehicle.geolocation = arrayCoords;
								}
								
								vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
								var newLatLng = new L.LatLng(vehicle.lat, vehicle.lon);
								// vehicle.marker.setLatLng(newLatLng);// = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
								// vehicle.marker.bindPopup(vehicle.infowWindowContent);

								// vehicle.marker.on('popupclose', function(e) {
								// 	vehicle.toggleInfoWdw = false;
								// });
								// vehicle.marker.on('popupopen', function(e) {
								// 	vehicle.toggleInfoWdw = true;
								// });
								// if(vehicle.shownOnMap && canShowMultiple){
								// 	vehicle.marker.addTo(this.stateSvc.mapStatic);
								// }
							}
						}else{
							vehicle.shownOnMap = false;
							if(tmpShowns.length > 0){
								tmpShowns.forEach((mkr) => {
									if(mkr.unitid == vehicle.unitid){
										vehicle.shownOnMap = mkr.shownOnMap;
									}
								});
							}
							let symbol = vehicle.symboltype + 1;
							if (symbol < 10) {
								symbol = '0' + symbol;
							}
							vehicle.icon = iconbase + symbol + '.png';
							if(currentMapProvider == "Google"){
								vehicle.marker = new google.maps.Marker({
									position: vehicle.markerPosition,
									icon: iconbase + symbol + '.png'
								});
								vehicle.infoWindow = new google.maps.InfoWindow({
									content: vehicle.infowWindowContent
								});
								vehicle.infoWindow.shown = false;
								vehicle.marker.addListener('click', () => {
									this.updateInfoWd(vehicle);
									let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
									if(arrayCoords){
										vehicle.geolocation = arrayCoords;
									}
									// let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
									// if(!arrayCoords){
									// 	this.reverseGeocode(vehicle.lat, vehicle.lon)
									// 	.subscribe((res) => {
									// 		if(res && res != ""){
									// 			vehicle.geolocation = res;
									// 			vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
									// 			vehicle.infoWindow.setContent(vehicle.infowWindowContent);
									// 		}
									// 	})
									// }else{
									// 	vehicle.geolocation = arrayCoords;
									// }
									vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
									vehicle.infoWindow.setContent(vehicle.infowWindowContent);
									if (!vehicle.infoWindow.shown) {
										vehicle.infoWindow.open(vehicle.marker?.map, vehicle.marker);
										vehicle.infoWindow.shown = true;
										vehicle.toggleInfoWdw = true;
									} else {
										vehicle.infoWindow.close();
										vehicle.infoWindow.shown = false;
										vehicle.toggleInfoWdw = false;
									}
								});
								google.maps.event.addListener(vehicle.infoWindow,'closeclick',() => {
									vehicle.infoWindow.shown = false;
									vehicle.toggleInfoWdw = false;
									this.updateInfoWd(vehicle);
								});
							}else{
								var greenIcon = L.icon({
									iconUrl: iconbase + symbol + '.png'
								});
								vehicle.greenIcon = greenIcon;

								this.updateInfoWd(vehicle);
								let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
								if(arrayCoords){
									vehicle.geolocation = arrayCoords;
								}
								vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
								// if (!vehicle.toggleInfoWdw) {
								// 	vehicle.toggleInfoWdw = true;
								// } else {
								// 	vehicle.toggleInfoWdw = false;
								// }
								
								vehicle.marker = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
								vehicle.marker.bindPopup(vehicle.infowWindowContent);

								vehicle.marker.on('popupclose', function(e) {
									vehicle.toggleInfoWdw = false;
								});
								vehicle.marker.on('popupopen', function(e) {
									vehicle.toggleInfoWdw = true;
								});
								if(vehicle.shownOnMap && canShowMultiple){
									vehicle.marker.addTo(this.stateSvc.mapStatic);
								}
							}
							vehicle.eventLowerCase = vhcStt.toLowerCase().replace(/_/g, ' ');
							vehicle.odometerInt = (vehicle.mileage/1000).toFixed(1);
							if (vehicleGroups.indexOf(vehicle.groupName) == -1) {
								vehicleGroups.push(vehicle.groupName);
							}
						}
						vechiles.push(vehicle);
						toUpdateCoords[vehicle.unitid] = vehicle.coordinate;
					});
					this.stateSvc.setVehicleGroups(vehicleGroups);
					this.stateSvc.setPrevCoords(toUpdateCoords);

					vechiles.sort((a, b) => 
						a.description.toLowerCase().localeCompare(b.description.toLowerCase())
					);
					
					// update in state service, so any component can use the vehicel object
					this.stateSvc.setVehicles(vechiles);
					
					return vechiles;
				}),
				catchError(err => throwError(() => err))
			);
		}),
		catchError(err => throwError(() => err))
	);
	}

  getCredentialData(){
		return this.http.get('assets/.collection.json')
		.pipe(
			map((str) => {
				return str;
			}),
			catchError((error:any) => {
				return throwError(error);
			})
		)
	}
  
  updateVehicleUnit(vehicles, fleets){
		if(vehicles.length > 0){
			vehicles.forEach((vhcl) => {
				if(fleets.length > 0){
					fleets.forEach((fleet) => {
						if(vhcl.unitid == fleet.unitid){
							vhcl = fleet;
							return;
						}
					});
				}
			});
			this.stateSvc.setVehicles(vehicles);
		}
	}
	
	updateInfoWd(vhcl){
		let existings = this.stateSvc.staticVehicle;
		this.updateVehicleUnit(existings, vhcl);
	}
  
  updateVehicleOnMap(vehicles, filteredVehicles, unitid, mapIns, defaultTrue = false){
	let canShowMultiple = this.stateSvc.showMulVehicles;
	let tmpShowns:any = [];
	let boolShown = false;
	if(localStorage.getItem('markerShown')){
		tmpShowns = JSON.parse(localStorage.getItem('markerShown'));
	}
	
	if(vehicles?.length > 0){
		// clear vehicle selection if only one can be selected
		if(!canShowMultiple && tmpShowns.length > 0){
			this.clearLocalVehicleOnMap(vehicles, unitid);
		}
		
		vehicles.forEach((vhcl) => {
			if(vhcl.unitid == unitid){
				boolShown = defaultTrue? defaultTrue : !vhcl.shownOnMap;
				vhcl.shownOnMap = boolShown;
				let mapProvider = this.stateSvc.getMapType();
				if(mapProvider == "Google"){
					if(vhcl.shownOnMap && mapIns?.mapTypeId && canShowMultiple){
						vhcl.marker.setMap(null);
						vhcl.marker.setMap(mapIns);
					}else{
						vhcl.marker.setMap(null);
					}
				}else{
					let symbol = vhcl.symboltype + 1;
					if (symbol < 10) {
						symbol = '0' + symbol;
					}
					let iconbase = this.apiSvc.getIconbase();
					vhcl.icon = iconbase + symbol + '.png';
					var greenIcon = L.icon({
						iconUrl: vhcl.icon
					});
					
					if(vhcl.shownOnMap && mapIns && canShowMultiple){
						if(vhcl.marker?._map){
							(vhcl.marker).remove();
						}
						setTimeout(() => {
							vhcl.marker = L.marker(vhcl.markerPositionOsm, {icon: greenIcon});
							vhcl.marker.bindPopup(vhcl.infowWindowContent);

							vhcl.marker.on('popupclose', function(e) {
								vhcl.toggleInfoWdw = false;
							});
							vhcl.marker.on('popupopen', function(e) {
								vhcl.toggleInfoWdw = true;
							});
							
							(vhcl.marker).addTo(mapIns);
						},300);
					}else{
						if(vhcl.marker?._map){
							(vhcl.marker).remove();
						}
					}
				}
				return;
			}
		});
		this.stateSvc.setVehicles(vehicles);
	}
	if(filteredVehicles?.length > 0){
		// clear vehicle selection if only one can be selected
		if(!canShowMultiple && tmpShowns.length > 0){
			this.clearLocalVehicleOnMap(filteredVehicles, unitid);
		}
		filteredVehicles.forEach((vhcl) => {
			if(vhcl.unitid == unitid){
				vhcl.shownOnMap = boolShown;
				let mapProvider = this.stateSvc.getMapType();
				if(mapProvider == "Google"){
					if(vhcl.shownOnMap && mapIns?.mapTypeId  && canShowMultiple){
						vhcl.marker.setMap(null);
						vhcl.marker.setMap(mapIns);
					}else{
						vhcl.marker.setMap(null);
					}
				}else{
					if(vhcl.shownOnMap && mapIns && canShowMultiple){
						if(vhcl.marker?._map){
							vhcl.marker.remove();
						}
						
						vhcl.marker = L.marker(vhcl.markerPositionOsm, {icon: vhcl.greenIcon});
						vhcl.marker.bindPopup(vhcl.infowWindowContent);

						vhcl.marker.on('popupclose', function(e) {
							vhcl.toggleInfoWdw = false;
						});
						vhcl.marker.on('popupopen', function(e) {
							vhcl.toggleInfoWdw = true;
						});
						setTimeout(() => {
							vhcl.marker.addTo(mapIns);
						},300);
					}else{
						if(vhcl.marker?._map){
							vhcl.marker.remove();
						}
					}
				}
				return;
			}
		});
		this.stateSvc.setVehicleFiltered(filteredVehicles);
	}
	
	let recordExist = false;
	if(!canShowMultiple){
		tmpShowns = [];
	}
	if(tmpShowns.length > 0){
		tmpShowns.forEach((mkr) => {
			if(mkr.unitid == unitid){
				mkr.shownOnMap = boolShown;
				recordExist = true;
				return;
			}
		});
	}
	
	if(!recordExist){
		let objToStore = {
			unitid: unitid,
			shownOnMap: boolShown
		};
		tmpShowns.push(objToStore);
	}
	
	localStorage.setItem('markerShown',JSON.stringify(tmpShowns));
  }
  
  getAllMobileEvents(code, startSel, startAt, endAt): Observable <any>{
	// init value
	let mobileEventData:any = [];
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	// encrypt using blowfish library
	let hash = this.authSvc.hashBlowfish(user.owner);
	let endpoint = this.apiSvc.getEndpointUrl();
	if(user.subaccount && !moment(startSel).isBetween(user.subaccountdatestart, user.subaccountdateend)) {
		return throwError('Date picked is out of range');
	}
	let enc = code+'!'+hash+'!'+startAt+'!'+endAt+'!ALL';
	let fullPathUrl = endpoint + 'GetEvents/' + enc;
	return this.http.get(fullPathUrl)
	.pipe(
		map((results:any) => {
			results.forEach((res) => {
				mobileEventData.push(this.apiSvc.wsr2obj(res));
			})
			
			return mobileEventData;
		}),
		catchError((error:any) => {
			error.statusText = 'Data size limit exceeded. Please select different date or time range';
			return throwError(error);
		})
	)
  }
  
  getSelectedEventMobileEvent(vehicleUnitId, eventCode, startSel, startAt, endAt): Observable <any> {
	// init value
	let mobileEventData:any = [];
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	// encrypt using blowfish library
	let hash = this.authSvc.hashBlowfish(user.owner);
	let endpoint = this.apiSvc.getEndpointUrl();
	if(user.subaccount && !moment(startSel).isBetween(user.subaccountdatestart, user.subaccountdateend)) {
		return throwError('Date picked is out of range');
	}
	var enc = eventCode+'!'+hash+'!'+startAt+'!'+endAt+'!'+vehicleUnitId;
	let fullPathUrl = endpoint + 'GetEvents/' + enc;
	return this.http.get(fullPathUrl)
	.pipe(
		map((results:any) => {
			results.forEach((res) => {
				mobileEventData.push(this.apiSvc.wsr2obj(res));
			})
			
			return mobileEventData;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	)
  }
  
  getMobileEvent(unitid, startAt, endAt): Observable <any>{
	// init value
	let mobileData:any = [];
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	let endpoint = this.apiSvc.getEndpointUrl();
	if(user.subaccount && !moment(startAt).isBetween(user.subaccountdatestart, user.subaccountdateend)) {
		return throwError('Date picked is out of range');
	}
	let enc = user.owner+'|'+unitid+'|'+startAt+'|'+endAt;
	// encrypt using blowfish library
	let hash = this.authSvc.hashBlowfish(enc);
	let fullPathUrl = endpoint + 'GetMobileRaw/' + hash;
	return this.http.get(fullPathUrl)
	.pipe(
		map((results:any) => {
			results.forEach((res) => {
				mobileData.push(this.apiSvc.wsr2obj(res));
			})
			
			return mobileData;
		}),
		catchError((error:any) => {
			error.statusText = "Connection reset. Please shorten the date range";
			return throwError(error);
		})
	)
  }
  
  clearLocalVehicleOnMap(vehicles, unitid){
	let currentMapProvider = this.stateSvc.getMapType();
	vehicles.forEach((vhcl) => {
		if(vhcl.unitid != unitid){
			vhcl.shownOnMap = false;
			if(currentMapProvider == "Google"){
				vhcl.marker.setMap(null);
			}else{
				vhcl.marker.remove();
			}
		}
	})
  }

  clearAllLocalVehicleOnMap(){
	let currentMapProvider = this.stateSvc.getMapType();
	let vehicles:any = this.stateSvc.staticVehicle;
	vehicles.forEach((vhcl) => {
		vhcl.shownOnMap = false;
		if(currentMapProvider == "Google"){
			vhcl.marker.setMap(null);
		}else{
			vhcl.marker.remove();
		}
	})
	this.stateSvc.setVehicles(vehicles);
  }
  
  setRangeTrips(range){
	localStorage.setItem('trip-start', range[0]);
	localStorage.setItem('trip-end', range[1]);
  }
  
  getRangeTrips(){
	let range = [
		localStorage.getItem('trip-start')? parseFloat(localStorage.getItem('trip-start')) : 0,
		localStorage.getItem('trip-end')? parseFloat(localStorage.getItem('trip-end')) : 24
	];
	
	return range;
  }
  
  getVehicleInfo(vehicles, unitid){
	let vhclAct:any = {};
	vehicles.forEach((vhcl) => {
		if(vhcl.unitid == unitid){
			vhclAct = vhcl;
			return;
		}
	})
	
	return vhclAct;
  }
  
  processUserPois(map){
	let currentMapProvider = this.stateSvc.getMapType();
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	let poisList:any = [];
	
	let poiColor = {
		"Global": "#FC3A99",
		"User": "#9400FF"
	};
	let pois = user.pois;
	if(pois.length > 0){
		pois.forEach((poi) => {
			let poiMarker:any;
			let poiMap:any;
			let infoWindow:any;
			if(currentMapProvider == 'Google'){
				poiMarker = new google.maps.Marker({
					position: {lat: poi.lat, lng: poi.lng},
					map: null
				});
				poiMap = new google.maps.Circle({
					strokeColor: poi.username == "Global" ? poiColor.Global : poiColor.User,
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: poi.username == "Global" ? poiColor.Global : poiColor.User,
					fillOpacity: 0.35,
					map: null,
					center: {lat: poi.lat, lng: poi.lng},
					radius: poi.radius
				});
				infoWindow = new google.maps.InfoWindow({
					content: "<div class='vehicle--summary-header'><span class='vehicle--plate'>POI: " + poi.name + "</span></div>" +
					"<div><small class='text-muted'>" + poi.username + "</small></div>",
					position: {lat: poi.lat, lng: poi.lng}
				});
				infoWindow.shown = false;
				poiMarker.addListener('click', function () {
					if (!infoWindow.shown) {
						infoWindow.open(map, poiMarker);
					} else {
						infoWindow.close();
					}
				});
			}else{
				let markerIcon = L.icon({
					iconUrl: 'assets/images/ui/map_marker.png'
				});

				poiMarker = L.marker([poi.lat,poi.lng], {icon: markerIcon});
				poiMarker.bindPopup("<div class='vehicle--summary-header'><span class='vehicle--plate'>POI: " + poi.name + "</span></div>" +
					"<div><small class='text-muted'>" + poi.username + "</small></div>");

				poiMap = L.circle([poi.lat,poi.lng], {
					color: poi.username == "Global" ? poiColor.Global : poiColor.User,
					fillColor: poi.username == "Global" ? poiColor.Global : poiColor.User,
					fillOpacity: 0.35,
					radius: poi.radius,
					stroke: true,
					weight: 2,
					opacity: 0.8,
				})
			}
			poisList.push(poiMap);
			poisList.push(poiMarker);
		});
	}
	this.stateSvc.setUserPois(poisList);
  }
  
  processUserZones(map){
	let currentMapProvider = this.stateSvc.getMapType();
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	let user:any = JSON.parse(userString);
	
	let zonesList:any = [];
	let zones = user.zones;
	
	let polygonalColor = {
		"KeepIn": "#1AAF54",
		"KeepOut": "#FC0D1B",
		"InOutOk": "#FFFD38",
		"Overlay": "#1072BD"
	};
	if(zones.length > 0){
		zones?.forEach((zone) => {
			let polyCoordinates = zone.points.split('|');
			let polyCoordinateFinal = [];
			let polyCoordinateHighest:any = {lat: '', lng: ''}; // to store their highest point of the zone
			if(currentMapProvider == "Google"){
				polyCoordinates.forEach((polyCoordinate, key) => {
					let tmp = polyCoordinate.split(':');
					polyCoordinateFinal[key] = {lat: parseFloat(tmp[0]), lng: parseFloat(tmp[1])};
					if (polyCoordinateHighest.lat == '' || tmp[0] > polyCoordinateHighest.lat) {
						polyCoordinateHighest = polyCoordinateFinal[key];
					}
				})
				let zoneMap = new google.maps.Polygon({
					paths: polyCoordinateFinal,
					strokeColor: polygonalColor[zone.type],
					strokeOpacity: 0.8,
					strokeWeight: 1,
					fillColor: polygonalColor[zone.type],
					fillOpacity: 0.1
				});
				zonesList.push(zoneMap);

				// push to below because when using circle or polygonal overlay
				// the overlay must be draw first in the map at the highest point of the zone
				let infoWindow:any = new google.maps.InfoWindow({
					content: "<div class='vehicle--summary-header'><span class='vehicle--plate'>Zone: " + zone.name + "</span></div>" +
					"<div><small class='text-muted'>" + zone.type + "</small></div>",
					position: polyCoordinateHighest,
					//suppressMapPan: true
				});

				infoWindow.shown = false;
				zoneMap.addListener('click', function () {
					infoWindow.shown = !infoWindow.shown;
					if (infoWindow.shown) {
						infoWindow.open(map, zoneMap);
					} else {
						infoWindow.close();
					}
				});
			}else{
				polyCoordinates.forEach((polyCoordinate, key) => {
					let tmp = polyCoordinate.split(':');
					polyCoordinateFinal[key] = {lat: parseFloat(tmp[0]), lng: parseFloat(tmp[1])};
					if (polyCoordinateHighest.lat == '' || tmp[0] > polyCoordinateHighest.lat) {
						polyCoordinateHighest = polyCoordinateFinal[key];
					}
				});
				let zoneMap = L.polygon(polyCoordinateFinal, {
					color: polygonalColor[zone.type],
					fillColor: polygonalColor[zone.type],
					fillOpacity: 0.1,
					stroke: true,
					weight: 1,
					opacity: 0.8,
				});
				zoneMap.bindPopup("<div class='vehicle--summary-header'><span class='vehicle--plate'>Zone: " + zone.name + "</span></div>" +
					"<div><small class='text-muted'>" + zone.type + "</small></div>");
				zonesList.push(zoneMap);
			}
			
		});
	}
	this.stateSvc.setUserZones(zonesList);
  }
  
  addTwoTime(startTime, endTime) {
	  let times = [ 0, 0, 0 ]
	  let max = times.length

	  let a = (startTime || '').split(':')
	  let b = (endTime || '').split(':')

	  // normalize time values
	  for (let i = 0; i < max; i++) {
		a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i])
		b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i])
	  }

	  // store time values
	  for (let i = 0; i < max; i++) {
		times[i] = a[i] + b[i]
	  }

	  let hours:any = times[0]
	  let minutes:any = times[1]
	  let seconds:any = times[2]

	  if (seconds >= 60) {
		let m = (seconds / 60) << 0
		minutes += m
		seconds -= 60 * m
	  }

	  if (minutes >= 60) {
		let h = (minutes / 60) << 0
		hours += h
		minutes -= 60 * h
	  }

	  if(hours < 10){
		hours = '0' + hours;
	  }

	  return hours + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
	}

	getVehicleByPlate(plate): Observable <any>{
		let zonesData:any = [];
		let hash = this.authSvc.hashBlowfish(plate);
		let endpoint = this.apiSvc.getPlateEndpointUrl();
		let fullPathZoneUrl = endpoint + encodeURI(plate);
		return this.http.get(fullPathZoneUrl)
		.pipe(
			map((zones:any) => {
				zones.forEach((zone) => {
					zonesData.push(this.apiSvc.wsr2obj(zone));
				})
				return zonesData;
			}),
			catchError((error:any) => {
				return throwError(error);
			})
		)
	}

	reverseGeocode(lat, lon){
		let baseUrl = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+lat+","+lon+"&key=AIzaSyARcR8g54_ekDkA-Y7YBvGwYe7cC9MFiWg";
		return this.http.get(baseUrl)
		.pipe(
			map((results:any) => {
				let valStr = "";
				if(results?.results[0]){
					results.results.forEach((res) => {
						if((res?.types[0] == "street_address")){
							let strCord = lat + ", " + lon;
							this.stateSvc.setDecodedCoords(strCord, res.formatted_address);
							valStr = res.formatted_address;
							return;
						}
					})
				}
				if(results?.results[0] && valStr == ""){
					results.results.forEach((res) => {
						if((res?.types).includes("route")){
							let strCord = lat + ", " + lon;
							this.stateSvc.setDecodedCoords(strCord, res.formatted_address);
							valStr = res.formatted_address;
							return;
						}
					})
				}
				if(results?.results[0] && valStr == ""){
					results.results.forEach((res) => {
						if((res?.types).includes("premise")){
							let strCord = lat + ", " + lon;
							this.stateSvc.setDecodedCoords(strCord, res.formatted_address);
							valStr = res.formatted_address;
							return;
						}
					})
				}
				if(results?.results[0] && valStr == ""){
					results.results.forEach((res) => {
						if((res?.types).includes("locality")){
							let strCord = lat + ", " + lon;
							this.stateSvc.setDecodedCoords(strCord, res.formatted_address);
							valStr = res.formatted_address;
							return;
						}
					})
				}

				return valStr;
			})
		);
	}

	writeInfoContent(vhcl, othersAttr, geoloc){
		let baseShareUrl = this.apiSvc.baseendpoint;
		let encVhc = encodeURIComponent(btoa(vhcl.unitid));
		let userObj = this.stateSvc.getLocalSession();
		let encUsr = encodeURIComponent(btoa(userObj?.username));
		let visibleFields = this.stateSvc.getMapFields();
		if(!visibleFields || visibleFields?.length == 0){
			visibleFields = this.stateSvc.getMapFieldIds();
		}
		baseShareUrl += "public-vehicle/"+encUsr+'/'+encVhc;
		let str = '<div style="width:300px;padding:10px;"><div class="vehicle--summary-header '+vhcl.unitid+'">'+
          '<span class="vehicle--plate" style="width:215px;float:left;"><strong>' + vhcl.description + '</strong></span>'+
          '<span style="float:right;width:60px"><a class="clickable colchooser"><i title="Value Setting" class="fa fa-gear" style="color:black;font-size:24px;"></i></a></span>' +
          '</div>' +
          '<div style="margin-bottom:10px;"><small class="text-muted">' + vhcl.convertedTime + '</small></div>' +
          '<div style="width:100%;overflow:hidden;font-size:15px;">';
			visibleFields.forEach((fld) => {
				str += '<div style="width:'+fld.width+'%;float:left;padding-right:5px;">';
				if(fld.value){
					if(fld.col == 'coordinate'){
						let urlEnc = encodeURIComponent(vhcl.geolocation);
						let mapStrGl = "https://www.google.com/maps?q="+vhcl.lat+","+vhcl.lon;
						let mapStr = '<a class="clickable refreshGeoloc" data-unitid="'+vhcl.unitid+'">'+vhcl.lat+","+vhcl.lon+'</a> &nbsp;<a target="_blank" href="'+mapStrGl+'" title="View on Map"><i class="fa fa-external-link"></i></a>';
						str += '<p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong>'+mapStr+'</p>';
					}else{
						str += '<p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong> ' + (vhcl[fld.col]? vhcl[fld.col] : '-') + '</p>';
					}
				}
				str += '</div>';
			});
			str += '</div>'+
          //'<p class="mdb-5">'+baseShareUrl+'</p>' +
		  '<button class="btn btn-info gen-share-link" data-vehicle-id="'+vhcl.unitid+'" style="width: 100%;" type="button" >Generate Share Link</button>' +
          '</div>';

		return str;
  	}

	writeInfoContentOpenMap(vhcl, othersAttr, geoloc){
		let baseShareUrl = this.apiSvc.baseendpoint;
		let encVhc = encodeURIComponent(btoa(vhcl.unitid));
		let userObj = this.stateSvc.getLocalSession();
		let encUsr = encodeURIComponent(btoa(userObj?.username));
		let visibleFields = this.stateSvc.getMapFields();
		if(!visibleFields || visibleFields?.length == 0){
			visibleFields = this.stateSvc.getMapFieldIds();
		}
		baseShareUrl += "public-vehicle/"+encUsr+'/'+encVhc;
		let str = '<div style="width:300px;padding:10px;"><div class="vehicle--summary-header '+vhcl.unitid+'">'+
          '<span class="vehicle--plate" style="width:215px;float:left;"><strong>' + vhcl.description + '</strong></span>'+
          '<span style="float:right;width:60px"><a class="clickable colchooser"><i title="Value Setting" class="fa fa-gear" style="color:black;font-size:24px;"></i></a></span>' +
          '</div>' +
          '<div style="margin-bottom:10px;"><p class="text-muted" style="font-size:12px;">' + vhcl.convertedTime + '</p></div>' +
          '<div style="width:100%;overflow:hidden;font-size:15px;">';
			visibleFields.forEach((fld) => {
				str += '<div style="width:'+fld.width+'%;float:left;padding-right:5px;">';
				if(fld.value){
					if(fld.col == 'coordinate'){
						let urlEnc = encodeURIComponent(vhcl.geolocation);
						let mapStrGl = "https://www.google.com/maps?q="+vhcl.lat+","+vhcl.lon;
						let mapStr = '<a class="clickable refreshGeoloc" data-unitid="'+vhcl.unitid+'">'+vhcl.lat+","+vhcl.lon+'</a> &nbsp;<a target="_blank" href="'+mapStrGl+'" title="View on Map"><i class="fa fa-external-link"></i></a>';
						str += '<p class="mdb-0" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong>'+mapStr+'</p>';
					}else{
						str += '<p class="mdb-0" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong> ' + (vhcl[fld.col]? vhcl[fld.col] : '-') + '</p>';
					}
				}
				str += '</div>';
			});
			str += '</div>'+
          //'<p class="mdb-5">'+baseShareUrl+'</p>' +
		  '<button class="btn btn-info gen-share-link" data-vehicle-id="'+vhcl.unitid+'" style="width: 100%;" type="button" >Generate Share Link</button>' +
          '</div>';

		return str;
  	}

	getUsersVehicles(uname=null) {
		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		let userId = user?.id;
		if(uname){
			userId = uname;
		}

		return this.getCredentialData().pipe(
			switchMap((sett: any) => {
				if (!sett?.collection_keys?.base_url) {
					return throwError(() => new Error('Invalid credential data'));
				}

				let endpoint = sett.collection_keys.base_url;
				let headKey = sett.collection_keys.master;
				let fullPathUrl = endpoint + "vehicle/getChildVehicle?userId=" + userId;
				const head = new HttpHeaders()
				.set('version', '1.0')
				.set('Accept-Language', 'en')
				.set('key', headKey);

				return this.http.get(fullPathUrl, { headers: head }).pipe(
					map((results: any) => {
						return results?.data;
					})
				)
			})
		)
	}

	getVehicleTracks(vehicle,startDate,endDate,incStop=0): Observable<any> {

		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		return this.getCredentialData().pipe(
			switchMap((sett: any) => {
				if (!sett?.collection_keys?.base_url) {
					return throwError(() => new Error('Invalid credential data'));
				}

				let endpoint = sett.collection_keys.base_url;
				let headKey = sett.collection_keys.master;
				let iconbase = this.apiSvc.getIconbase();
				let fullPathUrl = endpoint + 'track/getTrackList';

				const head = new HttpHeaders()
					.set('version', '1.0')
					.set('Accept-Language', 'en')
					.set('Content-Type', 'application/json')
					.set('key', headKey);
				
				let i:any = {
					filterTime:0,
					stopStatus:incStop,
					posStatus:0,
					beginTime:startDate,
					endTime:endDate,
					queryType:"1",
					queryParam:vehicle
				};

				// Initialize from an object
				let paramsFromObject = new HttpParams({ fromObject: i });
				
				return this.http.get(fullPathUrl, { headers: head, params:paramsFromObject }).pipe(
					map((results: any) => {
						if(results?.data?.trackList){
							return results?.data?.trackList;
						}else{
							return [];
						}
					}),
					catchError(err => throwError(() => err))
				);
			}),
			catchError(err => throwError(() => err))
		);
	}

	getVehicleTripTracksolid(vehicle,startDate,endDate): Observable<any> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.device.track.list",
			"access_token": this.stateSvc.getTraksolidtoken(),
			imei:vehicle,
			begin_time: startDate,
			end_time: endDate,
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.authSvc.getTimeStamp()
		};

		let readyQuery = this.authSvc.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		)
		.pipe(
			map((result: any) => {
				let res:any = {};
				if(result?.code == 0){
					res = result?.result;
				}
				return res;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getVehicleDrivingReport(vehicle,startDate,endDate): Observable<any> {

		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		return this.getCredentialData().pipe(
			switchMap((sett: any) => {
				if (!sett?.collection_keys?.base_url) {
					return throwError(() => new Error('Invalid credential data'));
				}

				let endpoint = sett.collection_keys.base_url;
				let headKey = sett.collection_keys.master;
				let iconbase = this.apiSvc.getIconbase();
				let fullPathUrl = endpoint + 'drivingReport/list';

				const head = new HttpHeaders()
					.set('version', '1.0')
					.set('Accept-Language', 'en')
					.set('Content-Type', 'application/json')
					.set('key', headKey);
				
				let i:any = {
					startTime:startDate,
					endTime:endDate,
					queryType:"1",
					queryParams:[vehicle]
				};

				// Initialize from an object
				// let paramsFromObject = new HttpParams({ fromObject: i });
				
				return this.http.post(fullPathUrl, i, { headers: head }).pipe(
					map((results: any) => {
						return results?.data;
					}),
					catchError(err => throwError(() => err))
				);
			}),
			catchError(err => throwError(() => err))
		);
	}

	getVehicleAlarms(vehicle,startDate,endDate,ids,page=1, pageSize=1000): Observable<any> {

		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		return this.getCredentialData().pipe(
			switchMap((sett: any) => {
				if (!sett?.collection_keys?.base_url) {
					return throwError(() => new Error('Invalid credential data'));
				}

				let endpoint = sett.collection_keys.base_url;
				let headKey = sett.collection_keys.master;
				let iconbase = this.apiSvc.getIconbase();
				let fullPathUrl = endpoint + 'alarm/getAlarmInfo';

				const head = new HttpHeaders()
					.set('version', '1.0')
					.set('Accept-Language', 'en')
					.set('Content-Type', 'application/json')
					.set('key', headKey);
				let i:any = {
					startTime:startDate,
					endTime:endDate,
					queryType:"1",
					queryParams:vehicle,
					ids:ids,
					pageNumber: page,
					pageSize: 1000
				};

				// Initialize from an object
				let paramsFromObject = new HttpParams({ fromObject: i });
				
				return this.http.post(fullPathUrl, i, { headers: head }).pipe(
					catchError(err => throwError(() => err))
				);

			}),
			catchError(err => throwError(() => err))
		);
	}

	getVehicleAlarmsAll(
		vehicle: any,
		startDate: string,
		endDate: string,
		ids: any
		){

		const fetchPage = (page: number): Observable<any> => {
			let pageSize = 1000;
			return this.getVehicleAlarms(vehicle, startDate, endDate, ids, page, pageSize).pipe(
			switchMap((res: any) => {

				const data = res?.data || [];

				// Adjust these based on your real API response
				const currentPage = res?.page || page;
				const currRecords = currentPage * pageSize;
				const totalPages = res?.total;

				if (currRecords < totalPages) {
				return fetchPage(page + 1).pipe(
					map(next => [...data, ...next])
				);
				}

				return of(data);
			})
			);
		};

		return fetchPage(1);
	}

	getVehicleTrakcsAll(
		vehicles: any,
		startDate: string,
		endDate: string,
		incStop:any
		){
		
		let loops = vehicles?.length;
		let startCount = 0;
		const fetchPage = (page: number): Observable<any> => {
			let vehicle = vehicles[page];
			return this.getVehicleTracks(vehicle, startDate, endDate,incStop).pipe(
				switchMap((res: any) => {
					const data = res || [];

					if ((page + 1) < loops && vehicles[page+1]) {
						return fetchPage(page + 1).pipe(
							map(next => [...data, ...next])
						);
					}

					return of(data);
				})
			);
		};

		return fetchPage(startCount);
	}

	getUsersTracksolidVehicles(uname=null) {
		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		let userId = user?.account;
		if(uname){
			userId = uname;
		}

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.user.device.list",
			"target" : userId,
			"access_token": this.stateSvc.getTraksolidtoken(),
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.authSvc.getTimeStamp()
		};

		let readyQuery = this.authSvc.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		)
		.pipe(
			map((result: any) => {
				let res:any = {};
				if(result?.code == 0){
					res = result?.result;
				}
				return res;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getVehicleTracksolids(uname: string | null = null): Observable<any> {
		let userString = sessionStorage.getItem('user');
		let user: any = userString ? JSON.parse(userString) : null;

		let currentMapProvider = this.stateSvc.getMapType();

		let userId = uname ?? user?.account;
		let iconbase = this.apiSvc.getIconbase();

		let tmpShowns:any = [];
		if(localStorage.getItem('markerShown')){
			tmpShowns = JSON.parse(localStorage.getItem('markerShown'));
		}
		
		// existing vehicles
		let existings = this.stateSvc.staticVehicle;
		
		let canShowMultiple = this.stateSvc.showMulVehicles;
		let objIds = this.stateSvc.getUsersVehicleIds();

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.user.device.location.list",
			"target" : userId,
			"access_token": this.stateSvc.getTraksolidtoken(),
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.authSvc.getTimeStamp()
		};

		let readyQuery = this.authSvc.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		let allDevicesObj:any = this.stateSvc.getUsersVehicleObjIds();
		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		).pipe(
			map((results: any) => {
				if (results?.code == 0 && results?.result.length == 0) {
					// no vehicle found from backend
					throw new Error('No vehicle found');
				}
				// set vehicle object
				let vechiles:any = [];
				let vehicleGroups:any = [];
				let toUpdateCoords:any = {};
				let prevCoords = this.stateSvc.getPrevCoords();
				results?.result?.forEach((res:any) => {
					let vehicle:any = res;
					vehicle.unitid = vehicle.imei;
					vehicle.plate = vehicle.deviceName;
					vehicle.description = vehicle.plate;
					// vehicle.color = vehicle.plateColor;
					vehicle.bearing = vehicle.direction;
					vehicle.direction = this.getHeadingVehicle(vehicle.bearing);
					vehicle.engine = this.getEngineTracksolidStatus(vehicle.accStatus);
					// vehicle.drivernamedefault = vehicle.driverName;
					// vehicle.driveid = vehicle.drivernamedefault? 1 : 0;
					vehicle.symboltype = this.getTracksolidSymbolMapping(vehicle.icon || "none");
					vehicle.groupname = allDevicesObj[vehicle.unitid]?.deviceGroup;
					vehicle.currentMileage = parseFloat(vehicle.currentMileage? vehicle.currentMileage : "0");
					vehicle.mileage = vehicle.currentMileage;
					vehicle.odometer = (vehicle.currentMileage).toFixed(1);
					vehicle.level = vehicle.trackerOil;
					vehicle.tankvolume = 0;
					if(user && !uname){
						if(user.username != user.owner && vehicle.subaccountname.toLowerCase() != user.username.toLowerCase()) {
							return;
						}
					}

					let vhcStt = this.getVehicleTracksolidStates(vehicle.status, vehicle.gpsTime);
					vehicle.event = vhcStt;
					
					vehicle.lon = vehicle.lng;
					vehicle.coordinate = vehicle.lat + ', ' + vehicle.lon;
					vehicle.location = vehicle.coordinate;
					vehicle.menuGeocode = true;
					vehicle.batteryPercent = (parseFloat(vehicle.batteryPowerVal || 0)).toFixed(2) + "%";
					let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
					if(arrayCoords){
						vehicle.location = arrayCoords;
					}
					vehicle.is_moving = false;
					if(prevCoords[vehicle.unitid] && prevCoords[vehicle.unitid] != vehicle.coordinate){
						vehicle.is_moving = true;
					}
					let othersAttr = (parseFloat(vehicle.trailerid)).toFixed(2);
					othersAttr = vehicle.batteryPercent;

					let currentDate = new Date();

					const dateStr = vehicle.gpsTime;
					let localTime:any = null;
					if(vehicle.gpsTime){
						// Convert to ISO format (important)
						const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
						date.setTime(date.getTime() + 28800000);
						localTime = date;
						// Get milliseconds
						const timestamp = date.getTime();
						// Build .NET format
						const dotNetDate = "/Date(" + timestamp + "+0800)/";
						vehicle.updated = moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x');
						// let currentMoment = moment();
						// let isAfterNow = vehicle.updated.isAfter(currentMoment);
						// vehicle.convertedTime = !isAfterNow? vehicle.updated.format('DD-MM-YYYY HH:mm:ss') : currentMoment.format('DD-MM-YYYY HH:mm:ss');
						// if(isAfterNow){
						// 	vehicle.updated = currentMoment;
						// }
						vehicle.convertedTime = vehicle.updated.format('DD-MM-YYYY HH:mm:ss');
					}else{
						// Convert to ISO format (important)
						const date = '-';
						// Get milliseconds
						const timestamp = '-';
						// Build .NET format
						const dotNetDate = "-";
						vehicle.updated = '-';
						// let currentMoment = moment();
						// let isAfterNow = vehicle.updated.isAfter(currentMoment);
						// vehicle.convertedTime = !isAfterNow? vehicle.updated.format('DD-MM-YYYY HH:mm:ss') : currentMoment.format('DD-MM-YYYY HH:mm:ss');
						// if(isAfterNow){
						// 	vehicle.updated = currentMoment;
						// }
						vehicle.convertedTime = '-';
					}
					vehicle.toggleInfoWdw = false;
					vehicle.fuelValue = (parseFloat(vehicle.trackerOil ?? 0)).toFixed(2);
					vehicle.otherAttribute = othersAttr;
					vehicle.fuel_usage = vehicle.trackerOil;
					vehicle.geolocation = "";
					// vehicle.infowWindowContent = "<div class='vehicle--summary-header "+vehicle.unitid+"'><span class='vehicle--plate '>" + vehicle.description + "</span></div>" +
					// 	"<div><small class='text-muted'>" + vehicle.convertedTime + "</small></div>" +
					// 	"<div>Driver: " + vehicle.drivernamedefault + "</div>" +
					// 	"<div>Engine: " + vehicle.engine + "</div>" +
					// 	"<div>Speed: " + vehicle.speed + "</div>" +
					// 	"<div>Direction: " + vehicle.direction + "</div>" +
					// 	"<div>Desc: " + vehicle.description + "</div>" +
					// 	"<div>Fuel: " + (parseFloat(vehicle.level) + parseFloat(vehicle.tankreserve)).toFixed(2) + "</div>" +
					// 	"<div>Others: " + othersAttr + "</div>";
					vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.location);
					// this.reverseGeocode(vehicle.lat, vehicle.lon)
					// .subscribe((res) => {
					// 	if(res && res != ""){
					// 		let currentGeoLoc = res;console.log(vehicle.description, currentGeoLoc)
					// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, currentGeoLoc);
					// 	}
					// })
					vehicle.markerPosition = {lat: vehicle.lat, lng: vehicle.lon};
					vehicle.markerPositionOsm = [vehicle.lat, vehicle.lon];
					let olediExist = false;
					let existing:any = {};
					if(existings.length > 0){
						existings.forEach((ex) => {
							if(ex.unitid == vehicle.unitid){
								olediExist = true;
								existing = ex;
								return;
							}
						});
					}
					if(olediExist){
						vehicle.shownOnMap = existing.shownOnMap;
						// vehicle.marker = existing.marker;
						vehicle.eventLowerCase = vhcStt;
						vehicle.odometerInt = (existing.currentMileage?? "0").toFixed(1);
						vehicle.icon = existing.icon;
						if (vehicleGroups.indexOf(vehicle.deviceGroup) == -1) {
							vehicleGroups.push(vehicle.deviceGroup);
						}
						if(currentMapProvider == "Google"){
							vehicle.infoWindow = existing.infoWindow;
							//vehicle.infoWindow.shown = existing.infoWindow.shown;

							if(vehicle.infoWindow.shown){
								let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
								if(!arrayCoords){
									// this.reverseGeocode(vehicle.lat, vehicle.lon)
									// .subscribe((res) => {
									// 	if(res && res != ""){
									// 		vehicle.geolocation = res;
									// 		vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
									// 		vehicle.infoWindow.setContent(vehicle.infowWindowContent);
									// 	}
									// })
								}else{
									vehicle.geolocation = arrayCoords;
								}
								vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
								vehicle.infoWindow.setContent(vehicle.infowWindowContent);
							}
							
							// if(canShowMultiple){
							// 	vehicle.marker.setPosition(vehicle.markerPosition);
							// 	vehicle.infoWindow.setContent(vehicle.infowWindowContent);
							// }
						}else{
							vehicle.infoWindow = existing.infoWindow;
							vehicle.toggleInfoWdw = existing.toggleInfoWdw;
							
							let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
							if(!arrayCoords){
								
							}else{
								vehicle.geolocation = arrayCoords;
							}
							
							vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
							var newLatLng = new L.LatLng(vehicle.lat, vehicle.lon);
							// vehicle.marker.setLatLng(newLatLng);// = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
							// vehicle.marker.bindPopup(vehicle.infowWindowContent);

							// vehicle.marker.on('popupclose', function(e) {
							// 	vehicle.toggleInfoWdw = false;
							// });
							// vehicle.marker.on('popupopen', function(e) {
							// 	vehicle.toggleInfoWdw = true;
							// });
							// if(vehicle.shownOnMap && canShowMultiple){
							// 	vehicle.marker.addTo(this.stateSvc.mapStatic);
							// }
						}
					}else{
						vehicle.shownOnMap = false;
						if(tmpShowns.length > 0){
							tmpShowns.forEach((mkr) => {
								if(mkr.unitid == vehicle.unitid){
									vehicle.shownOnMap = mkr.shownOnMap;
								}
							});
						}
						let symbol = vehicle.symboltype + 1;
						if (symbol < 10) {
							symbol = '0' + symbol;
						}
						vehicle.icon = iconbase + symbol + '.png';
						if(currentMapProvider == "Google"){
							vehicle.marker = new google.maps.Marker({
								position: vehicle.markerPosition,
								icon: iconbase + symbol + '.png'
							});
							vehicle.infoWindow = new google.maps.InfoWindow({
								content: vehicle.infowWindowContent
							});
							vehicle.infoWindow.shown = false;
							vehicle.marker.addListener('click', () => {
								this.updateInfoWd(vehicle);
								let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
								if(arrayCoords){
									vehicle.geolocation = arrayCoords;
								}
								// let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
								// if(!arrayCoords){
								// 	this.reverseGeocode(vehicle.lat, vehicle.lon)
								// 	.subscribe((res) => {
								// 		if(res && res != ""){
								// 			vehicle.geolocation = res;
								// 			vehicle.infowWindowContent = this.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
								// 			vehicle.infoWindow.setContent(vehicle.infowWindowContent);
								// 		}
								// 	})
								// }else{
								// 	vehicle.geolocation = arrayCoords;
								// }
								vehicle.infowWindowContent = this.writeInfoContent(vehicle, othersAttr, vehicle.geolocation);
								vehicle.infoWindow.setContent(vehicle.infowWindowContent);
								if (!vehicle.infoWindow.shown) {
									vehicle.infoWindow.open(vehicle.marker?.map, vehicle.marker);
									vehicle.infoWindow.shown = true;
									vehicle.toggleInfoWdw = true;
								} else {
									vehicle.infoWindow.close();
									vehicle.infoWindow.shown = false;
									vehicle.toggleInfoWdw = false;
								}
							});
							google.maps.event.addListener(vehicle.infoWindow,'closeclick',() => {
								vehicle.infoWindow.shown = false;
								vehicle.toggleInfoWdw = false;
								this.updateInfoWd(vehicle);
							});
						}else{
							var greenIcon = L.icon({
								iconUrl: iconbase + symbol + '.png'
							});
							vehicle.greenIcon = greenIcon;

							this.updateInfoWd(vehicle);
							let arrayCoords = this.stateSvc.getDecodedCoords(vehicle.coordinate);
							if(arrayCoords){
								vehicle.geolocation = arrayCoords;
							}
							vehicle.infowWindowContent = this.writeInfoContentOpenMap(vehicle, othersAttr, vehicle.geolocation);
							// if (!vehicle.toggleInfoWdw) {
							// 	vehicle.toggleInfoWdw = true;
							// } else {
							// 	vehicle.toggleInfoWdw = false;
							// }
							
							vehicle.marker = L.marker(vehicle.markerPositionOsm, {icon: greenIcon});
							vehicle.marker.bindPopup(vehicle.infowWindowContent);

							vehicle.marker.on('popupclose', function(e) {
								vehicle.toggleInfoWdw = false;
							});
							vehicle.marker.on('popupopen', function(e) {
								vehicle.toggleInfoWdw = true;
							});
							if(vehicle.shownOnMap && canShowMultiple){
								vehicle.marker.addTo(this.stateSvc.mapStatic);
							}
						}
						vehicle.eventLowerCase = vhcStt.toLowerCase().replace(/_/g, ' ');
						vehicle.odometerInt = (vehicle.mileage).toFixed(1);
						if (vehicleGroups.indexOf(vehicle.deviceGroup) == -1) {
							vehicleGroups.push(vehicle.deviceGroup);
						}
					}
					
					if (vehicle.accStatus == "1" && (vehicle.event == 'Idling')) {
						vehicle.status = 'idle';
					}else if (vehicle.accStatus == "0" ) {
						vehicle.status = 'stop';
					}else if (vehicle.accStatus == "1") {
						vehicle.status = 'active';
					}

					if(vehicle.gpsTime){
						currentDate.setTime(currentDate.getTime() - 86400000);
						if(currentDate.getTime() < localTime.getTime()){
							vehicle.status = 'active';
						}
					}

					vechiles.push(vehicle);
					toUpdateCoords[vehicle.unitid] = vehicle.coordinate;
				});
		
				this.stateSvc.setPrevCoords(toUpdateCoords);

				vechiles.sort((a, b) => 
					a.description.toLowerCase().localeCompare(b.description.toLowerCase())
				);
				
				return vechiles;
			}),
			catchError(error => {
				// 2. Intercept and handle errors gracefully
				console.error('Error occurred:', error);
				return of([]); // Always return a fallback observable
			})
		);
	}

	getVehicleTracksolidAlarms(vehicle,startDate,endDate,page=1, pageSize=1000): Observable<any> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.device.alarm.list",
			"access_token": this.stateSvc.getTraksolidtoken(),
			imei:vehicle,
			begin_time: startDate,
			end_time: endDate,
			page_no: page,
			page_size: pageSize,
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.authSvc.getTimeStamp()
		};

		let readyQuery = this.authSvc.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		)
		.pipe(
			map((result: any) => {
				let res:any = {};
				if(result?.code == 0){
					res = result?.result;
				}
				return res;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getVehicleTracksolidAlarmsAll(
		vehicle: any,
		startDate: string,
		endDate: string
		){

		const fetchPage = (page: number): Observable<any> => {
			let pageSize = 1000;
			return this.getVehicleTracksolidAlarms(vehicle, startDate, endDate, page, pageSize).pipe(
			switchMap((res: any) => {

				const data = res?.data || [];

				// Adjust these based on your real API response
				const currentPage = res?.page || page;
				const currRecords = currentPage * pageSize;
				const totalPages = res?.total;

				if (currRecords < totalPages) {
				return fetchPage(page + 1).pipe(
					map(next => [...data, ...next])
				);
				}

				return of(data);
			})
			);
		};

		return fetchPage(1);
	}

}
